import { AccessorsMutatorsDecorator, Model } from "../../helpers";
import { Subscription } from "./subscription.model";
import { Country } from "./country.model";
import { City } from "./city.model";

/**
 * @class BillingInformation
 *
 */
export class BillingInformation extends Model {

    /**
     * @param {Object|Subscription} value
     * @returns {Subscription}
     */
    setSubscription(value) {

        return value instanceof Subscription ? value : new Subscription(value);
    }

    /**
     * @param {Object|Country} value
     * @returns {Country}
     */
    setCountry(value) {

        if (!value) value = {id: 0, name: '', code: '', name_ar: ''};

        return value instanceof Country ? value : new Country(value);
    }

    /**
     * @param {Object|City} value
     * @returns {City}
     */
    setCity(value) {

        return value && (value instanceof City ? value : new City(value));
    }
}

AccessorsMutatorsDecorator('id', 'subscription', 'subscription_id', 'company_name', 'first_name', 'last_name', 'address', 'country_id', 'city_id',
    'phone_code', 'phone_number', 'additional_phone_code', 'additional_phone_number', 'city', 'country', 'email', 'email_to_confirm')(BillingInformation);


// WEBPACK FOOTER //
// ./src/pms-api/models/billing-information.model.js